import { Box } from '@mantine/core';
import { DateValue } from '@mantine/dates';
import { useState } from 'react';

import { InstagramAnalyticsData } from '../components/Instagram/AnalyticsData';
import { InstagramControlsPanel } from '../components/Instagram/ControlsPanel';

import { endOfDay, startOfDay } from '@/utils/dates';

export type InstagramAnalyticsFiltersState = {
  pageId: string;
  dates: [DateValue, DateValue];
  topic: string;
  pageLink: string;
  geo: string;
};

const getDefaultFilters = (): InstagramAnalyticsFiltersState => {
  const today = new Date();
  return {
    pageId: 'ALL',
    dates: [startOfDay(today), endOfDay(today)],
    topic: 'ALL',
    pageLink: 'ALL',
    geo: 'ALL',
  };
};

export const Instagram = () => {
  const [filters, setFilters] = useState(getDefaultFilters);

  return (
    <Box style={{ display: 'grid', height: 'calc(100vh - 105px)', gridTemplateRows: '70px auto' }}>
      <InstagramControlsPanel filters={filters} setFilters={setFilters} />
      <InstagramAnalyticsData {...filters} />
    </Box>
  );
};
